/* eslint-disable quotes */
import { FC, useState } from 'react';
import { Loader } from 'components';
import { StarIcon } from 'assets/icons';

const DEFAULT_TIPS = [
  "Type a short job description if you're not uploading files (e.g., 'replace faucet + parts').",
  "Add 'labor + parts' if you want it split out.",
  "Type 'tax included' or 'no tax' to fix totals.",
  'Upload a photo of the receipt/invoice if you have one.',
  "If a page is wrong, type 'ignore last page'."
];

interface AutoFillLoadingViewProps {
  title?: string;
  tips?: string[];
}

const AutoFillLoadingView: FC<AutoFillLoadingViewProps> = ({ title = 'Filling', tips = DEFAULT_TIPS }) => {
  const [tipIndex] = useState(() => Math.floor(Math.random() * tips.length));

  return (
    <div className="flex flex-col items-center p-6">
      <h2 className="mb-4 text-xl font-bold text-headingGray">{title}</h2>
      <Loader lottieClassName="h-28 w-28" />
      <p className="mb-10 text-17px font-semibold text-primaryText">This usually takes a few seconds...</p>
      <div
        className="mt-auto flex w-full max-w-[480px] gap-3 rounded-lg bg-[#A4D7FA4D] py-2.5 px-3"
        role="region"
        aria-label="Quick tip">
        <StarIcon className="text-accent-primary h-5 w-5 shrink-0" aria-hidden="true" />
        <div>
          <p className="mb-1 text-sbase font-semibold text-[#191915]">Quick tip</p>
          <p className="text-sbase font-medium text-primaryText" key={tipIndex}>
            {tips[tipIndex]}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AutoFillLoadingView;
